var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_795_24422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.012 27.3361C53.012 12.7577 41.1938 0.939453 26.6154 0.939453C12.037 0.939453 0.21875 12.7575 0.21875 27.3361C0.21875 40.5113 9.87167 51.4319 22.4909 53.4121V34.9664H15.7886V27.3361H22.4909V21.5206C22.4909 14.9049 26.4319 11.2506 32.4612 11.2506C35.3494 11.2506 38.3702 11.7662 38.3702 11.7662V18.2623H35.0417C31.7623 18.2623 30.7399 20.2971 30.7399 22.3847V27.3361H38.0608L36.8905 34.9664H30.7399V53.4121C43.3591 51.4319 53.012 40.5115 53.012 27.3361Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8909 34.9638L38.0612 27.3335H30.7403V22.3821C30.7403 20.2943 31.763 18.2597 35.0421 18.2597H38.3706V11.7636C38.3706 11.7636 35.3498 11.248 32.4616 11.248C26.4323 11.248 22.4913 14.9023 22.4913 21.518V27.3335H15.7891V34.9638H22.4913V53.4095C23.8557 53.6233 25.2347 53.7305 26.6158 53.7302C27.9969 53.7306 29.3759 53.6233 30.7403 53.4095V34.9638H36.8909Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_795_24422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.7933,
    height: 52.7933,
    fill: "white",
    transform: "translate(0.21875 0.939453)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.301b85f23dbd4b748a23d697c2aa2218.svg";
export { ForwardRef as ReactComponent };